import { Icon, Menu, MenuItem, Position } from "@blueprintjs/core"
import CustomPopover from "components/Atoms/CustomPopover"
import CustomTag from "components/Atoms/CustomTag"
import { VehicleMasterListQuery } from "generated/graphql"
import React from "react"

type ShowAlertsProps = {
  alerts: VehicleMasterListQuery["vehicleList"][0]["alerts"]
}

const ShowAlerts = ({ alerts }: ShowAlertsProps) => {
  return (
    <>
      {alerts?.length && alerts.length > 0 ? (
        <CustomPopover
          position={Position.BOTTOM}
          content={
            <Menu className="vt-overflow-list-menu">
              {alerts?.map((alert, idx) => {
                return (
                  <MenuItem
                    icon="warning-sign"
                    key={alert.message ?? idx}
                    text={alert.message}
                    label={alert.date}
                  />
                )
              })}
            </Menu>
          }
        >
          <CustomTag
            icon={<Icon className="mr-1" icon="warning-sign" iconSize={10} />}
            round={true}
            interactive={true}
            minimal
            intent="danger"
          >
            {alerts?.length} Alerts
          </CustomTag>
        </CustomPopover>
      ) : (
        <CustomTag
          round
          icon={<Icon className="mr-1" icon="tick" iconSize={10} />}
          intent="success"
          minimal
        >
          No Alerts!
        </CustomTag>
      )}
    </>
  )
}

export default ShowAlerts
